import { Select } from 'radix-ui'
import { cn } from '~/shared/lib/cn'

export function SelectSeparator({
  className,
  ...props
}: React.ComponentProps<typeof Select.Separator>) {
  return (
    <Select.Separator
      className={cn('bg-divider my-1 h-px', className)}
      {...props}
    />
  )
}
